//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from "lodash/debounce";
import { mapState, mapActions } from "vuex";
import { addBankCard } from "@/common/api/Amount";
import { sendPhoneCode, sendPhoneSMS } from "@/common/api/bindAuthenticate";

import MyBasePage from "../../../components/MyBasePage";

import FormField from "./components/FormField";
import IconPhone from "./components/IconPhone";
import IconEWallet from "./components/IconEWallet";

export default {
  components: {
    MyBasePage,
    FormField,
    IconPhone,
    IconEWallet,
  },
  data() {
    return {
      walletLists: [
        {
          bankName: "K豆",
          bankCode: "KD",
          usdtType: "KD",
          icon: require("../../../../assets/image/common/KD.png"),
          name: "K豆钱包",
        },
        {
          bankName: "JD钱包",
          bankCode: "JDPay",
          usdtType: "KD",
          icon: require("../../../../assets/image/common/JD.png"),
          name: "JD钱包",
        },
        {
          bankName: "365钱包",
          bankCode: "365Pay",
          usdtType: "KD",
          icon: require("../../../../assets/image/common/365.png"),
          name: "365钱包",
        },
      ],
      walletType: null,
      cardNumber: "",
      submitting: false,
      verify: {
        sending: false,
        cd: 0,
        code: "",
        timer: null,
      },
    };
  },
  async created() {
    // 判断是否实名认证
    if (!this.userInfo.nameValid) {
      this.$vux.toast.show({
        text: "请先完成实名认证",
        type: "cancel",
      });
      this.$router.replace({ path: "/My/AccountManat/VerifiedAuth" });
      return;
    }

    // 判断是否绑定手机
    if (!this.userInfo.mobileValid) {
      this.$vux.toast.show({
        text: "请先绑定手机",
        type: "cancel",
      });
      this.$router.replace({ path: "/My/AccountManat/mobileAuth" });
      return;
    }

    // 判断取款密码是否已设定
    if (
      this.linkList.isWithdrawPassword === "1" &&
      !this.userInfo.withdrawPasswordValid
    ) {
      this.$vux.toast.show({
        text: "请先设定取款密码",
        type: "cancel",
      });
      this.$router.replace({ path: "/My/AccountManat/WithdrawPasword" });
      return;
    }

    this.walletType = this.walletLists[0];

    // this.bankcard.personName = this.alipay.personName = this.userInfo.name
    // this.loadBanks()
  },
  computed: {
    ...mapState({
      // UUID
      UUID: (state) => state.UUID,
      // 用户信息
      userInfo: (state) => state.userInfo.userInfo,
      // 配置信息
      linkList: (state) => state.linkList,
    }),
  },
  methods: {
    ...mapActions(["getFirstInfo"]),

    /** 校验虚拟货币 */
    async validate() {
      // 校验地址
      if (!/^\w{11,40}$/.test(this.cardNumber)) {
        return {
          validate: false,
          msg: "地址不正确",
        };
      }
      // 校验验证码
      if (!/[1-9a-zA-Z]{4,6}/.test(this.verify.code)) {
        return {
          validate: false,
          msg: "验证码不正确",
        };
      }

      return { validate: true };
    },
    /** 发送验证码 */
    async handleSend() {
      if (this.verify.sending || this.verify.cd > 0) {
        return;
      }

      try {
        const [data, error] = await sendPhoneSMS({
          UUID: this.UUID,
          areaCode: this.userInfo.mobileArea || "86",
          phone: this.userInfo.mobilePhone,
        });
        if (error) {
          this.$vux.toast.show({
            text: error.message,
            type: "cancel",
          });
          return;
        }

        this.verify.cd = 150;
        this.verify.timer = setInterval(() => {
          if (this.verify.cd <= 0) {
            clearInterval(this.timer);
            return;
          }

          this.verify.cd = this.verify.cd - 1;
        }, 1000);
      } finally {
        this.verify.sending = false;
      }
    },
    /** 提交 */
    async handleSubmit() {
      if (this.submitting) {
        return;
      }

      try {
        this.submitting = true;

        // 根据类型调用对应的校验
        // bankcardValidate, aplipayValidate, usdtValidate
        const validation = await this.validate();
        if (!validation.validate) {
          this.$vux.toast.show({
            text: validation.msg,
            type: "cancel",
          });
          return;
        }

        // 将要提交的数据
        const form = {
          // 页面输入内容
          bankCode: this.walletType.bankCode,
          bankName: this.walletType.bankName,
          subBank: this.walletType.bankName,
          cardNumber: this.cardNumber,
          usdtPhoneCode: this.verify.code,
          UUID: this.UUID,
          withdrawPassword: "",
          personName: this.userInfo.name,
          bankBindPhone: this.userInfo.mobilePhone,
        };

        // 提交
        const [data, error] = await addBankCard(form);

        if (error) {
          this.$vux.toast.show({
            text: error.message,
            type: "cancel",
          });
          return;
        }

        this.getFirstInfo();
        this.$vux.toast.show({
          text: "钱包绑定成功",
          type: "success",
        });

        if (window.history.length < 2) {
          this.$router.replace("/My");
          return;
        }
        this.$router.go(-1);
      } finally {
        this.submitting = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Wallet/AddWallet/walletCom.vue